import { render, staticRenderFns } from "./ui-tooltip.vue?vue&type=template&id=3d924422&scoped=true&"
import script from "./ui-tooltip.vue?vue&type=script&lang=js&"
export * from "./ui-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./ui-tooltip.vue?vue&type=style&index=0&id=3d924422&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d924422",
  null
  
)

export default component.exports